import { render, staticRenderFns } from "./ChatDetailModal.vue?vue&type=template&id=051b4619&scoped=true&"
import script from "./ChatDetailModal.vue?vue&type=script&lang=js&"
export * from "./ChatDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatDetailModal.vue?vue&type=style&index=0&id=051b4619&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051b4619",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('051b4619')) {
      api.createRecord('051b4619', component.options)
    } else {
      api.reload('051b4619', component.options)
    }
    module.hot.accept("./ChatDetailModal.vue?vue&type=template&id=051b4619&scoped=true&", function () {
      api.rerender('051b4619', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hhemp/aiagent/modules/ChatDetailModal.vue"
export default component.exports